export function RangeCursor (pEditor, pRange)
{
  this.show = (targetNode, collapse) =>
  {
    var i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('div[data-waelementhidecursor]'),
        sel = pEditor.iFrame.getSelection(),
        range,
        isExternalStopSaveUndo = pEditor.undoRedo.isStopSaveUndo;

    pEditor.undoRedo.isStopSaveUndo = true;

    targetNode = targetNode || pEditor.iFrameDoc.body;
    collapse = (collapse != null) ? collapse : true;

    for (i = elements.length; i--;)
    {
      if (elements[i] && elements[i].parentNode)
      {
        elements[i].parentNode.removeChild(elements[i]);
      }
    }

    pEditor.layer.currentAbsElement = null;

    try
    {
      sel.removeAllRanges();
      sel.selectAllChildren(pEditor.iFrameDoc.body);
      sel.removeAllRanges();
      range = pEditor.iFrameDoc.createRange();

      if (targetNode.nodeName.toUpperCase() === 'IMG')
      {
        range.selectNode(targetNode);
      }
      else
      {
        range.selectNodeContents(targetNode);
      }

      range.collapse(collapse);
      sel.addRange(range);
    }
    catch (err) {}

    if (!isExternalStopSaveUndo)
    {
      pEditor.undoRedo.saveUndoDo(true);
      pEditor.undoRedo.isStopSaveUndo = false;
    }
  };


  this.hide = () =>
  {
    var element,
        sel = pEditor.iFrame.getSelection(),
        range;

    if (sel)
    {
      pEditor.layer.currentAbsElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();
      element = pEditor.iFrameDoc.body.querySelector('DIV[data-waelementhidecursor]');

      if (!element)
      {
        element = pEditor.iFrameDoc.createElement('DIV');
        element.setAttribute('data-waelementhidecursor', '1');
        element.setAttribute('style', 'position: absolute; left: -3700px; top: -3700px; width: 1px; height: 1px; overflow: hidden;');
        pEditor.iFrameDoc.body.appendChild(element);
      }

      sel.removeAllRanges();
      sel.selectAllChildren(element);
      sel.removeAllRanges();
      range = pEditor.iFrameDoc.createRange();
      range.selectNodeContents(element);
      sel.addRange(range);

      pRange.save();
    }
  };
}